import { createFileRoute, redirect } from '@tanstack/react-router';

import { aiModelsSearchSchema } from '@/features/ai-models/aiModelsSearch';

/**
 * Kept for links made before spec 224 grouped this page under another entry:
 * the AI models page is the Models tab of AI usage now. The search carries over, so a link that opened a form or a period still
 * does.
 */
export const Route = createFileRoute('/workspaces/$workspaceId/ai-models')({
  validateSearch: aiModelsSearchSchema,
  beforeLoad: ({ params, search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/ai-usage/models',
      params: { workspaceId: params.workspaceId },
      search: search,
      replace: true,
    });
  },
});
